import React from "react";
import './style.css'
import { Card, Accordion, Button } from "react-bootstrap";

export default function QA() {
  const questions = [
    {
      question: "למי מיועד אתר לויירז?",
      answer: "לויירז הינו פלטפורמה המיועדת לעורכי דין בלבד, שמטרותיה הן להסדיר את אופן הפניית התיקים בין עורכי הדין המנויים באתר, באופן שיבטיח ללקוחותיהם את השירות המקצועי והיעיל ביותר. בנוסף, הפלטפורמה מאפשרת למשתמשים לערוך התייעצויות מקצועיות ביניהם ואף לפנות למשתמשים אחרים לצורך קבלת ליווי או סיוע בתיק או עניין משפטי.",
    },
    {
      question: "מה היתרון בפרסום תיק להעברה בלויירז על פני השימוש בפלטפורמות אינטרנטיות אחרות (פייסבוק למשל)?",
      answer: "להבדיל מפלטפורמות אינטרנטיות אחרות, משתמשי לויירז מקבלים מידע רב אודות רמתם המקצועית של משתמשים אחרים במהירות וביעילות, באופן המאפשר איתור נכון של עורך דין להפניית התיק. מנגנון סינון התוצאות באתר על פי פרמטרים קבועים, מגדיל באופן ניכר את הסיכויים בהצלחת הפנית התיק והשירות המקצועי שיקבל הלקוח.",
    },
    {
      question: 'מהם התנאים להפניית תיקים למשתמש אחר?',
      answer: <ul>
      <li>קיימים מספר תנאים הכרחיים שעל המשתמשים לעמוד בהם לצורך הפנית התיק, כגון: (1) המשתמשים (המעביר והנעבר) הינם עורכי דין, החברים בלשכת עורכי הדין ואין מניעה שיעסקו במקצוע; (2) המשתמש הנעבר סבור כי יש ביכולתו לקבל את התיק או העניין המשפטי לטיפולו, באופן שיעניק ללקוח שירות מקצועי העומד בסטנדרטים המקובלים; (3) המשתמש המעביר קיבל את הסכמת לקוחו להפנות את התיק או העניין המשפטי לידי משתמש אחר; (4) הלקוח אישר, טרם הפניית התיק, כי המשתמש הנעבר רשאי לפנות אליו; (5) המשתמשים (המעביר והנעבר) ערכו ביניהם הסכם בכתב לעניין הפניית התיק או העניין המשפטי, פרטי הלקוח ומנגנון התגמול בגין הפניית התיק מהמשתמש המעביר לידי המשתמש הנעבר.</li>
      <li>למידע נוסף, ניתן לעיין בתנאי השימוש באתר.</li>
      </ul>
    },
    {
      question: 'האם האתר גובה עמלה על ההפניות בין המשתמשים?',
      answer: 'לא. לויירז אינו גובה עמלה או תגמול כלשהו בגין הפניות התיקים או העניינים המשפטיים בין המשתמשים.',
    },
    {
      question: 'האם יש אחוזים קבועים להעברת תיקים? האם אפשר להעביר בחינם?',
      answer: 'לויירז אינו מתערב במערכת ההסכמות בין המשתמשים ואינו מבקש לקבל מידע כלשהו מהמשתמשים אודות ההסכמות שבינם לבין לקוחותיהם ולבין משתמשים אחרים, הכל בכפוף לעמידת המשתמשים בתנאי השימוש.',
    },
    {
      question: 'כיצד נמדדת רמתם המקצועית של המשתמשים באתר?',
      answer: <ul>
      <li>לויירז עושה שימוש במנגנון דירוג למשתמשים באתר. דירוג עורכי הדין מאפשר, בין היתר, איתור מדויק של משתמש להפניית תיק או עניין משפטי, באופן שיגדיל הן את סיכויי הצלחת הפניית התיק או העניין המשפטי והן את השירות המקצועי שיקבל הלקוח לאחר ההפניה.</li>
      <li>מנגנון דירוג המשתמשים עושה שימוש במאפיינים קבועים מראש הכוללים, בין היתר, את הותק של המשתמש כעורך הדין, תחומי התמחותו, כמות הפניות שקיבל ממשתמשים אחרים באתר, מידת המעורבות שלו באתר והמלצות המתקבלות על ידי המשתמשים באתר.</li>
      </ul>,
    },
    {
      question: 'כיצד עובד מנגנון הדירוג?',
      answer: 'הדירוג הכללי של המשתמשים משוקלל על ידי 2 סוגי דירוגים – דירוג ראשי – המתבצע באופן אוטומטי ומביא בחשבון הן מאפייני דירוג שנקבעו מראש והן את מידת המעורבות של המשתמש באתר; ו – דירוג "המלצה" – המתבסס על המלצות שיתקבלו באמצעות "תיוג" (Endorsement) המשתמש על ידי משתמשים אחרים. המלצה תתקבל, בין היתר, בגין ייעוץ משפטי שהעניק המשתמש בלוח ההתייעצויות המקצועיות או לאחר הפניה מוצלחת של תיק או עניין משפטי לטיפולו.',
    },
    {
      question: 'כיצד מנגנון הדירוג בא לידי ביטוי באתר?',
      answer: <ul>
      <li>דירוג המשתמשים יבוא לידי ביטוי באופן ביו יוצג המשתמש בתוצאות חיפוש של משתמשים אחרים. כלומר, דירוג גבוה של משתמש יבוא לידי ביטוי בהופעה במקומות גבוהים יותר ברשימת תוצאות החיפוש. חשוב לציין, כי דירוג נמוך של משתמש אינו מהווה בהכרח אינדיקציה על רמתו המקצועית או רמת מעורבותו של המשתמש באתר, אלא כי קיימים מאפייני דירוג בהם קיבל המשתמש ציון נמוך באופן שהשפיע על הדירוג הכללי (למשל – כשמדובר על משתמש שהינו עורך דין צעיר בעל ותק יחסית נמוך). </li>
      <li>הדירוג הכללי הינו דינמי ומתעדכן אחת לתקופה קבועה מראש.</li>
      <li>חשוב להדגיש, כי דירוג המשתמשים בא לידי ביטוי אך ורק במיצוב המשתמש בתוצאות החיפוש וברשימות אחרות באתר, בהן סדר הופעת המשתמשים בלוח התוצאות מושפע מרמת דירוגם. </li>
      <li>למידע נוסף אודות מנגנון הדירוג, ניתן לעיין בתנאי השימוש באתר.</li>
      </ul>,
    },
    {
      question: 'מהו לוח ההתייעצויות המקצועיות?',
      answer: <ul>
      <li>לוח ההתייעצויות המקצועיות מהווה פלטפורמה לשימוש המשתמשים המנויים באתר, לצורך קיום התייעצויות בסוגיות משפטיות שונות. לוח ההתייעצויות המקצועיות הינו כלי יעיל ונוח לשימוש המשתמשים באופן שיאפשר להם להעלות את רמתם המקצועית ובכך לשפר את הייעוץ המשפטי הניתן ללקוחותיהם. </li>
      <li>שימוש תורם בלוח ההתייעצויות המקצועיות, אף מהווה משקל בשיפור הדירוג הפנימי של המשתמשים באתר.</li>
      </ul>,
    },
    {
      question: 'האם לוח ההתייעצויות המקצועיות פתוח לפניות של מי שאינם עורכי דין?',
      answer: 'לא. לויירז מהווה פלטפורמה לעורכי הדין בלבד וכך גם לוח ההתייעצויות המקצועיות. זאת, במטרה לאפשר לעורכי הדין להתייעץ באופן חופשי ביניהם ובכך לשפר את רמתם המקצועית והיכולת לטפל בתיק כזה או אחר.',
    },
    {
      question: 'מה זה לוח "באתי לעזרת חבר"?',
      answer: <ul>
      <li>לוח "באתי לעזרת חבר" מאפשר למשתמשים לפנות למשתמשים אחרים לקבלת ליווי או סיוע בתיק או עניין משפטי תוך קביעת מנגנון תגמול ביניהם. מטרת הלוח הינה לאפשר למשתמשים לשתף פעולה ביניהם באופן שיאפשר לשני הצדדים להבטיח כי הלקוחות יטופלו ברמה המקצועית הגבוהה ביותר, ללא הצורך בהעברת הטיפול בלקוח לידי המשתמש האחר. </li>
      <li>באמצעות לוח "באתי לעזרת חבר" המשתמשים בלויירז יכולים לפנות לקבל ליווי וסיוע ממשתמשים אחרים הן לצורך ליווי על ידי משתמש ותיק ומנוסה בניהול תיק או עניין משפטי שנמצא בתחום התמחותו והן לצורך קבלת סיוע בכתיבת מסמכים משפטיים, לרבות כתבי טענות, הסכמים וחוות דעת משפטיות.</li>
      </ul>,
    }
  ];
  return (
    <Accordion defaultActiveKey="0">
      {questions.map((qa, index) =>
        <Card>
          <Card.Header className = 'qa-header'>
            <Accordion.Toggle as={Button} variant="link" eventKey={index}>
            <i className="fa fa-plus qa-plus-icon" aria-hidden="true"></i>
              {qa.question}
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey={index}>
            <Card.Body className = 'qa-body'>{qa.answer}</Card.Body>
          </Accordion.Collapse>
        </Card>
      )}
    </Accordion>
  );
}
